(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("pakhshkit-js"));
	else if(typeof define === 'function' && define.amd)
		define(["pakhshkit-js"], factory);
	else if(typeof exports === 'object')
		exports["ottanalytics"] = factory(require("pakhshkit-js"));
	else
		root["pakhshkit"] = root["pakhshkit"] || {}, root["pakhshkit"]["ottanalytics"] = factory(root["pakhshkit"]["core"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition


// WEBPACK FOOTER //
// ott-analytics/webpack/universalModuleDefinition